import { render, staticRenderFns } from "./footer-1.vue?vue&type=template&id=1e176574&scoped=true&"
import script from "./footer-1.vue?vue&type=script&lang=ts&"
export * from "./footer-1.vue?vue&type=script&lang=ts&"
import style0 from "./footer-1.vue?vue&type=style&index=0&id=1e176574&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e176574",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VContainer,VIcon,VListItem,VListItemContent,VListItemIcon,VListItemTitle})
